// ITEM40-GROUP-MANAGEMENT-TEST: o botao mais separa criar contato de criar grupo.
import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Chip} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Group,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Android as AndroidIcon,
  AccountBalanceWallet as WalletIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import {
  FilterAltOff,
  FilterAlt,
  PlaylistAddCheckOutlined,
  NotificationsActiveOutlined,
  PersonAddAlt1Outlined,
  ForumOutlined
} from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import NewWhatsAppGroupModal from "../NewWhatsAppGroupModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { KanbanLanesFilter } from "../KanbanLanesFilter";
import { UsersFilter } from "../UsersFilter";
import { canUseBroadTicketView } from "../../utils/ticketVisibility";
import { createTicketSearchHandlers } from "../../utils/ticketSearchInput";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";
import NoReplyFilterModal from "../NoReplyFilterModal";
import NoReplyTicketsList from "../NoReplyTicketsList";
import {
  buildAllNoReplyPreferences,
  normalizeNoReplyPreferences
} from "../../utils/noReplyFilter";
import toastError from "../../errors/toastError";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: 0,
    minHeight: 64,
    fontSize: 11,
    marginLeft: 0,
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: 0,
    margin: 0,
    boxSizing: "border-box",
    borderTop: theme.mode === "light" ? "1px solid #dce5ef" : "1px solid #344255",
    borderBottom: theme.mode === "light" ? "1px solid #dce5ef" : "1px solid #344255",
    borderRight: theme.mode === "light" ? "1px solid #e3e9f1" : "1px solid #303d50",
    opacity: 0.76,
    color: theme.mode === "light" ? "#667085" : "#aab4c4",
    "&.Mui-selected": {
      opacity: 1,
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
      backgroundColor: theme.mode === "light" ? "#ffffff" : "#253246",
      boxShadow: theme.mode === "light"
        ? "inset 0 1px 0 #ffffff"
        : "inset 0 1px 0 rgba(255,255,255,0.04)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(66, 82, 180, 0.06)" : "rgba(255, 255, 255, 0.06)",
    },
    "&:last-child": {
      borderRight: "none",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
      fontSize: 8,
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      minHeight: 60,
      paddingTop: 2,
      paddingBottom: 2,
      fontSize: 10,
    },
  },

  tabIndicator: {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    background: theme.mode === "light"
      ? "linear-gradient(90deg, #D4AF37, #C89B2A)"
      : "linear-gradient(90deg, #F2D675, #FFE49A)",
    transition: "all 0.3s ease",
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    overflow: "visible",
    flexShrink: 0,
    backgroundColor: theme.mode === "light" ? "#f3f7fc" : "#1c2736",
    borderRadius: 10,
    border: theme.mode === "light" ? "1px solid #d9e4f0" : "1px solid #334155",
    boxShadow: theme.mode === "light"
      ? "0 2px 8px rgba(43, 58, 91, 0.07)"
      : "0 3px 10px rgba(0, 0, 0, 0.18)",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.75),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: "6px 7px",
    "& .MuiGrid-container": {
      width: "100%",
    },
    "& .MuiGrid-item": {
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",
      gap: 0,
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      marginTop: 3,
      marginBottom: 4,
      padding: "4px 5px",
      borderRadius: 10,
      "& .MuiGrid-item": {
        rowGap: 3,
      },
    },
  },
  serachInputWrapper: {
    flex: 1,
    flexShrink: 0,
    minHeight: 42,
    background: theme.mode === "light" ? "#ffffff" : "#182130",
    display: "flex",
    alignItems: "center",
    borderRadius: 13,
    padding: "3px 4px 3px 7px",
    border: theme.mode === "light" ? "1px solid #dfe5ef" : "1px solid #344155",
    boxShadow: theme.mode === "light"
      ? "0 5px 16px rgba(44, 58, 88, 0.07)"
      : "0 5px 16px rgba(0, 0, 0, 0.16)",
    marginTop: 0,
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    transition: "border-color 160ms ease, box-shadow 160ms ease",
    "&:focus-within": {
      borderColor: theme.mode === "light" ? "#D4AF37" : "#F2D675",
      boxShadow: theme.mode === "light"
        ? "0 0 0 3px rgba(0, 135, 90, 0.11)"
        : "0 0 0 3px rgba(0, 201, 122, 0.13)",
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      minHeight: 34,
      marginTop: 0,
      marginBottom: 3,
      padding: "1px 3px 1px 6px",
      borderRadius: 10,
    },
  },

  searchIcon: {
    color: theme.mode === "light" ? "#778397" : "#9aa6b8",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
    fontSize: 20,
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 10,
    fontSize: 13,
    color: theme.mode === "light" ? "#273247" : "#edf1f7",
  },

  searchFilterButton: {
    flexShrink: 0,
    width: 34,
    height: 34,
    marginLeft: 4,
    color: theme.mode === "light" ? "#526176" : "#b9c4d4",
    borderRadius: 9,
    border: theme.mode === "light" ? "1px solid #dce3ee" : "1px solid #3a4659",
    backgroundColor: theme.mode === "light" ? "#f7f9fc" : "#202b3b",
    "&:hover": {
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
      backgroundColor: theme.mode === "light" ? "#eaf6f1" : "#233b34",
    },
  },
  searchFilterButtonActive: {
    color: "#ffffff",
    borderColor: "transparent",
    background: "linear-gradient(145deg, #D4AF37, #9B7118)",
    "&:hover": {
      color: "#ffffff",
      background: "linear-gradient(145deg, #007A51, #005C3B)",
    },
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-12px",
    top: "-10px",
    transform: "translate(30%, -30%)",
    backgroundColor: "#D4AF37",
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },

  compactTabLabel: {
    position: "relative",
    minHeight: 50,
    padding: "17px 3px 3px",
    flexWrap: "nowrap",
    overflow: "visible",
    '@media (max-height: 850px), (max-width: 1440px)': {
      minHeight: 46,
      padding: "15px 2px 2px",
    },
  },

  compactTabCount: {
    position: "absolute",
    top: 2,
    left: "auto",
    right: 4,
    zIndex: 3,
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    borderRadius: 9,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#D4AF37",
    color: "#ffffff",
    fontSize: 10,
    lineHeight: 1,
    fontWeight: 700,
    boxShadow: "0 1px 4px rgba(0,0,0,0.20)",
    pointerEvents: "none",
    '@media (max-height: 850px), (max-width: 1440px)': {
      top: 2,
      left: "auto",
      right: 3,
      minWidth: 17,
      height: 17,
      padding: "0 4px",
      fontSize: 9,
    },
  },
  
  modernTabs: {
    minHeight: 68,
    flexShrink: 0,
    borderRadius: 10,
    backgroundColor: theme.mode === "light" ? "#f5f8fc" : "#182332",
    borderLeft: theme.mode === "light" ? "1px solid #dce5ef" : "1px solid #344255",
    borderRight: theme.mode === "light" ? "1px solid #dce5ef" : "1px solid #344255",
    boxShadow: "none",
    padding: 0,
    margin: "6px 8px",
    overflow: "hidden",
    transition: "all 0.3s ease",
    position: "relative",
    '@media (max-height: 850px), (max-width: 1440px)': {
      minHeight: 64,
      padding: 0,
      margin: "4px 6px",
      borderRadius: 8,
      "& .MuiTab-root": {
        minHeight: 60,
      },
    },
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    width: 34,
    height: 34,
    marginRight: 1,
    alignSelf: "center",
    color: theme.mode === "light" ? "#3f6a5b" : "#b9c9c3",
    cursor: "pointer",
    borderRadius: 10,
    transition: "background-color 160ms ease, color 160ms ease",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#eaf6f1" : "#203a31",
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
    },
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? "#D4AF37" : "#F2D675",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 34,
    width: 34,
    border: theme.mode === "light" ? "1px solid #d6deea" : "1px solid #3b485d",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#222d3e",
    borderRadius: 10,
    marginRight: 7,
    padding: 0,
    minWidth: 'auto',
    boxShadow: theme.mode === "light"
      ? "0 4px 11px rgba(39, 54, 86, 0.08)"
      : "0 4px 12px rgba(0, 0, 0, 0.20)",
    transition: "transform 150ms ease, border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      transform: "translateY(-1px)",
      borderColor: theme.mode === "light" ? "#D4AF37" : "#F2D675",
      backgroundColor: theme.mode === "light" ? "#f0faf6" : "#223b33",
      boxShadow: theme.mode === "light"
        ? "0 7px 15px rgba(0, 105, 70, 0.15)"
        : "0 7px 16px rgba(0, 0, 0, 0.28)",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      marginRight: 6,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      marginRight: 6,
    },
  },
  activeButton: {
    borderColor: "transparent",
    background: theme.mode === "light"
      ? "linear-gradient(145deg, #D4AF37, #9B7118)"
      : "linear-gradient(145deg, #F2D675, #D4AF37)",
    boxShadow: "0 7px 16px rgba(0, 135, 90, 0.28)",
    "&:hover": {
      borderColor: "transparent",
      background: theme.mode === "light"
        ? "linear-gradient(145deg, #007A51, #005C3B)"
        : "linear-gradient(145deg, #12D889, #009764)",
    },
    "&.Mui-selected, &.Mui-selected:hover": {
      color: "#ffffff",
      borderColor: "transparent",
      background: theme.mode === "light"
        ? "linear-gradient(145deg, #D4AF37, #9B7118)"
        : "linear-gradient(145deg, #F2D675, #D4AF37)",
      boxShadow: "0 7px 16px rgba(0, 135, 90, 0.28)",
    },
  },
  standardIcon: {
    color: theme.mode === "light" ? "#657187" : "#aeb8c8",
    fontSize: 19,
    "&:hover": {
      color: theme.mode === "light" ? "#D4AF37" : "#F2D675",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: "#ffffff",
  },
  quickFiltersRow: {
    display: "flex",
    gap: 7,
    padding: "5px 10px 4px",
    flexWrap: "wrap",
    alignItems: "center",
    flexShrink: 0,
    '@media (max-height: 850px), (max-width: 1440px)': {
      gap: 4,
      padding: "2px 7px",
    },
  },
  toolbarActions: {
    width: "100%",
    minWidth: 0,
    flexWrap: "nowrap !important",
    gap: 4,
    overflow: "visible",
  },
  toolbarSpacer: {
    flex: "1 1 8px",
    minWidth: 4,
  },
  toolbarHighlightChip: {
    flexShrink: 0,
    height: 28,
    marginRight: 2,
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 700,
    '@media (max-height: 850px), (max-width: 1440px)': {
      height: 25,
      marginRight: 1,
      fontSize: 9,
    },
  },
  myAttendancesChip: {
    height: 34,
    minWidth: 64,
    paddingLeft: 1,
    paddingRight: 1,
    "& .MuiChip-icon": {
      marginLeft: 5,
      marginRight: -2,
    },
    "& .MuiChip-label": {
      paddingLeft: 5,
      paddingRight: 5,
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      height: 31,
      minWidth: 59,
    },
  },
  myAttendancesLabel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "10px",
    whiteSpace: "normal",
  },
  quickFilterChip: {
    height: 26,
    borderRadius: 9,
    fontSize: 11,
    fontWeight: 500,
    borderColor: theme.mode === "light" ? "#dce3ee" : "#39465a",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#1c2635",
    color: theme.mode === "light" ? "#58657a" : "#b9c2d1",
    transition: "transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease",
    "&:hover": {
      transform: "translateY(-1px)",
      borderColor: theme.mode === "light" ? "#6eae96" : "#3b9d76",
      boxShadow: theme.mode === "light"
        ? "0 5px 12px rgba(42, 55, 86, 0.09)"
        : "0 5px 12px rgba(0,0,0,0.20)",
    },
    "&.MuiChip-colorPrimary": {
      color: "#ffffff",
      borderColor: "transparent",
      background: "linear-gradient(145deg, #D4AF37, #9B7118)",
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      height: 23,
      fontSize: 10,
    },
  },
  noReplyBadge: {
    top: 1,
    right: 3,
    minWidth: 20,
    height: 20,
    padding: "0 6px",
    borderRadius: 7,
    border: theme.mode === "light" ? "2px solid #ffffff" : "2px solid #171f2c",
    color: "#ffffff",
    backgroundColor: "#d78317",
    fontSize: 10,
    fontWeight: 700,
    boxShadow: "0 4px 10px rgba(190, 112, 14, 0.28)",
  },
  noReplyChip: {
    height: 29,
    paddingRight: 4,
    borderRadius: 10,
    border: theme.mode === "light" ? "1px solid #edc26f" : "1px solid #7a602f",
    color: theme.mode === "light" ? "#754706" : "#ffdda0",
    background: theme.mode === "light"
      ? "linear-gradient(145deg, #fff9e9, #ffefc8)"
      : "linear-gradient(145deg, #3a2d18, #302517)",
    boxShadow: theme.mode === "light"
      ? "0 6px 14px rgba(198, 129, 24, 0.15)"
      : "0 6px 15px rgba(0,0,0,0.22)",
    fontSize: 11,
    fontWeight: 700,
    transition: "transform 150ms ease, box-shadow 150ms ease",
    "& .MuiChip-icon": {
      color: theme.mode === "light" ? "#b86e0d" : "#f6bf5d",
    },
    "& .MuiChip-deleteIcon": {
      color: theme.mode === "light" ? "#a6630d" : "#efc574",
    },
    "&:hover": {
      transform: "translateY(-1px)",
      background: theme.mode === "light"
        ? "linear-gradient(145deg, #fff6dd, #ffe8b2)"
        : "linear-gradient(145deg, #43341c, #362919)",
      boxShadow: "0 8px 18px rgba(190, 112, 14, 0.22)",
    },
    "&.MuiChip-colorPrimary": {
      color: "#ffffff",
      borderColor: "transparent",
      background: "linear-gradient(145deg, #d78a1e, #b66a0c)",
      "& .MuiChip-icon, & .MuiChip-deleteIcon": {
        color: "#ffffff",
      },
    },
    '@media (max-height: 850px), (max-width: 1440px)': {
      height: 24,
      fontSize: 10,
    },
  },
  filterPanel: {
    margin: "2px 8px 7px",
    position: "relative",
    zIndex: 4,
    flexShrink: 0,
    borderRadius: 13,
    border: theme.mode === "light" ? "1px solid #e0e6f0" : "1px solid #344155",
    backgroundColor: theme.mode === "light" ? "#fafbfe" : "#1a2433",
    boxShadow: theme.mode === "light"
      ? "0 7px 18px rgba(40, 54, 85, 0.07)"
      : "0 8px 20px rgba(0,0,0,0.18)",
    overflow: "visible",
  },
  filterGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 0,
    padding: "6px 6px 0",
    gridAutoRows: "minmax(0, auto)",
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  filterActions: {
    padding: "5px 10px 9px",
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
  },
  filterQuickOptions: {
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
    padding: "4px 8px 2px",
    borderTop: theme.mode === "light" ? "1px solid #edf0f5" : "1px solid #2b3749",
  },
  activeFilterBanner: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    margin: "3px 8px 0",
    padding: "7px 10px",
    borderRadius: 10,
    backgroundColor: theme.mode === "light" ? "#fff8e8" : "#332a1c",
    border: theme.mode === "light" ? "1px solid #f0d396" : "1px solid #6a542d",
  },
  activeFilterText: {
    fontSize: 12,
    color: theme.mode === "light" ? "#8a570d" : "#f2ca82",
    fontWeight: 500,
    lineHeight: 1.35,
  },
  clearFilterButton: {
    marginLeft: "auto",
    color: theme.mode === "light" ? "#8a570d" : "#f2ca82",
    fontWeight: 600,
    textTransform: "none",
    whiteSpace: "nowrap",
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const estratizaGold = theme.mode === "light" ? "#D4AF37" : "#F2D675";
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [searchParam, setSearchParam] = useState("");
  const [noTag, setNoTag] = useState(false);
  const [noKanban, setNoKanban] = useState(false);
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [newItemChoiceOpen, setNewItemChoiceOpen] = useState(false);
  const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);

  const searchInputRef = useRef();
  // Busca operacional por identidade do contato: nome ou qualquer trecho do
  // numero. Mensagens nao entram aqui para "Igor" nao trazer chats que apenas
  // mencionaram esse nome no historico.
  const searchOnMessages = false;

  const { user, socket } = useContext(AuthContext);
  const { profile } = user;
  const canShowAllTickets = canUseBroadTicketView(user);
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const [chatbotCount, setChatbotCount] = useState(0);
  const [noReplyEnabled, setNoReplyEnabled] = useState(false);
  const [noReplyActive, setNoReplyActive] = useState(false);
  const [noReplyModalOpen, setNoReplyModalOpen] = useState(false);
  const [noReplyCount, setNoReplyCount] = useState(0);
  const [noReplySortSaving, setNoReplySortSaving] = useState(false);
  const previousNoReplyViewRef = useRef(null);
  const [noReplyPreferences, setNoReplyPreferences] = useState({
    deadlineValue: 1,
    deadlineUnit: "days",
    maxDeadlineValue: null,
    maxDeadlineUnit: null,
    skipWeekends: false,
    includedTagIds: [],
    includedKanbanTagIds: [],
    excludedTagIds: [],
    excludedKanbanTagIds: [],
    sortOrder: "DESC",
    onlyMine: false
  });

  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedKanbanLanes, setSelectedKanbanLanes] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/no-reply/preferences")
      .then(({ data }) => {
        if (!mounted) return;
        setNoReplyEnabled(data.enabled === true);
        if (data.preferences) {
          setNoReplyPreferences(normalizeNoReplyPreferences({
            ...data.preferences,
            onlyMine: user.profile === "admin" ? data.preferences.onlyMine : true
          }));
        }
      })
      .catch(() => {
        if (mounted) setNoReplyEnabled(false);
      });
    return () => { mounted = false; };
  }, [user.profile]);

  const applyNoReply = preferences => {
    if (!noReplyActive) {
      previousNoReplyViewRef.current = { tab, tabOpen };
    }
    setNoReplyPreferences(normalizeNoReplyPreferences({
      ...preferences,
      onlyMine: user.profile === "admin" ? preferences.onlyMine : true
    }));
    setNoReplyActive(true);
    setNoReplyModalOpen(false);
  };

  const deactivateNoReply = () => {
    const previous = previousNoReplyViewRef.current;
    setNoReplyActive(false);
    setNoReplyCount(0);
    setNoReplyModalOpen(false);
    if (previous) {
      setTab(previous.tab);
      setTabOpen(previous.tabOpen);
    }
    previousNoReplyViewRef.current = null;
  };

  const openNoReplyDefault = () => {
    setNoReplyPreferences(current => buildAllNoReplyPreferences({
      ...current,
      skipWeekends: false,
      includedTagIds: [],
      includedKanbanTagIds: [],
      excludedTagIds: [],
      excludedKanbanTagIds: [],
      sortOrder: "DESC",
      onlyMine: user.profile === "admin" ? current.onlyMine : true
    }));
    setNoReplyModalOpen(true);
  };

  const toggleNoReplySort = async () => {
    if (noReplySortSaving) return;
    const nextPreferences = normalizeNoReplyPreferences({
      ...noReplyPreferences,
      sortOrder: noReplyPreferences.sortOrder === "DESC" ? "ASC" : "DESC",
      onlyMine: user.profile === "admin" ? noReplyPreferences.onlyMine : true
    });
    setNoReplySortSaving(true);
    try {
      const { data } = await api.put("/no-reply/preferences", nextPreferences);
      setNoReplyPreferences(normalizeNoReplyPreferences(data.preferences || data));
    } catch (err) {
      toastError(err);
    } finally {
      setNoReplySortSaving(false);
    }
  };

  // O estado do olho precisa existir tambem no backend. O servidor valida o
  // perfil/permissao no banco antes de liberar qualquer payload amplo.
  useEffect(() => {
    if (!socket) return undefined;
    const syncShowAll = () => {
      socket.emit("setShowAllTickets", {
        enabled: canShowAllTickets && showAllTickets
      });
    };
    syncShowAll();
    socket.on("connect", syncShowAll);
    return () => socket.off("connect", syncShowAll);
  }, [socket, showAllTickets, canShowAllTickets]);

  useEffect(() => {
    if (!socket) return undefined;
    return () => socket.emit("setShowAllTickets", { enabled: false });
  }, [socket]);

  const handleToggleShowAllTickets = () => {
    if (!canShowAllTickets) return;
    if (showAllTickets && location.pathname !== "/tickets") {
      history.push("/tickets");
    }
    setShowAllTickets(previous => !previous);
  };
  const [myAttendances, setMyAttendances] = useState(false);
  const [unreadFilter, setUnreadFilter] = useState(false);

  // Referências estáveis para evitar RESET desnecessário na lista de search quando contexto muda
  const searchUsers = useMemo(
    () => myAttendances ? [user.id] : selectedUsers,
    [myAttendances, user.id, selectedUsers]
  );
  const searchStatusFilter = useMemo(
    () => myAttendances ? ["open", "pending", "closed", "chatbot"] : selectedStatus,
    [myAttendances, selectedStatus]
  );

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (!canShowAllTickets) {
      setShowAllTickets(false);
    }
  }, [canShowAllTickets]);

  useEffect(() => {
    // Verificar se há parâmetro 'tab' na URL ao carregar
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
      // Definir a tab principal primeiro
      if (tabParam === "pending") {
        setTab("open"); // "Aguardando" está dentro da tab "open"
      } else if (tabParam === "open") {
        setTab("open");
      } else if (tabParam === "closed") {
        setTab("closed");
      } else if (tabParam === "group") {
        setTab("open"); // "Grupos" está dentro da tab "open"
      }
      // Depois definir a sub-aba (tabOpen)
      setTimeout(() => {
        setTabOpen(tabParam);
      }, 50);
    }
  }, []);

  // Monitorar mudanças na URL para atualizar a aba quando necessário
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
      // Se o parâmetro tab mudou, atualizar a aba
      if (tabOpen !== tabParam) {
        // Definir a tab principal primeiro
        if (tabParam === "pending") {
          setTab("open"); // "Aguardando" está dentro da tab "open"
        } else if (tabParam === "open") {
          setTab("open");
        } else if (tabParam === "closed") {
          setTab("closed");
        } else if (tabParam === "group") {
          setTab("open"); // "Grupos" está dentro da tab "open"
        }
        // Depois definir a sub-aba (tabOpen) com um pequeno delay
        setTimeout(() => {
          setTabOpen(tabParam);
        }, 100);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch((previous) => !previous);
  }, [tab]);

  const searchTimeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(searchTimeoutRef.current), []);

  const { handleSearch, handleSearchKeyDown } = createTicketSearchHandlers({
    setSearchParam,
    setTab,
    setForceSearch,
    setFilter
  });

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    setSelectedTags(selecteds.map(item => item.id));
  };

  const handleSelectedKanbanLanes = (selecteds) => {
    // Só armazena — busca só dispara ao clicar "Filtrar agora"
    const hasNoTag = selecteds.some(lane => lane.id === 0);
    setNoKanban(hasNoTag);
    const laneTagIds = selecteds.filter(lane => lane.id !== 0).map(lane => lane.id);
    setSelectedKanbanLanes(laneTagIds);
  };

  const handleSelectedUsers = (selecteds) => {
    setSelectedUsers(selecteds.map(item => item.id));
  };

  const handleSelectedWhatsapps = (selecteds) => {
    setSelectedWhatsapp(selecteds.map(item => item.id));
  };

  const handleSelectedStatus = (selecteds) => {
    setSelectedStatus(selecteds.map(item => item.status));
  };

  const applyFilters = () => {
    const hasSelectedFilter = selectedStatus.length > 0 || selectedTags.length > 0 ||
      selectedKanbanLanes.length > 0 || selectedWhatsapp.length > 0 ||
      selectedUsers.length > 0 || selectedQueueIds.length > 0 || noTag || noKanban;
    if (hasSelectedFilter && tab !== "search") setTab("search");
    setForceSearch(prev => !prev);
    setFilter(false); // FIX PAINEL-RECOLHER
  };

  // FIX AVISO-FILTRO: computado a partir do estado real (nao um toggle separado) -
  // garante que o icone e o aviso sempre refletem se ha filtro de verdade aplicado
  const hasActiveFilter = !!searchParam || selectedTags.length > 0 || selectedKanbanLanes.length > 0 ||
    selectedWhatsapp.length > 0 || selectedStatus.length > 0 || selectedUsers.length > 0 ||
    selectedQueueIds.length > 0 || noTag || noKanban || myAttendances || unreadFilter;
  const hasAdvancedFilter = selectedTags.length > 0 || selectedKanbanLanes.length > 0 ||
    selectedWhatsapp.length > 0 || selectedStatus.length > 0 || selectedUsers.length > 0 ||
    selectedQueueIds.length > 0 || noTag || noKanban || unreadFilter;

  useEffect(() => {
    // Ao limpar o ultimo filtro, volta para a lista normal. Se ainda houver
    // outro filtro ativo (por exemplo, coluna + texto), preserva o consolidado.
    if (tab === "search" && !hasActiveFilter) setTab("open");
  }, [hasActiveFilter, tab]);

  const buildActiveFilterDescription = () => {
    const parts = [];
    if (searchParam) parts.push(`busca "${searchParam}"`);
    if (selectedUsers.length > 0) parts.push(`${selectedUsers.length} usuário(s)`);
    if (selectedWhatsapp.length > 0) parts.push(`${selectedWhatsapp.length} conexão(ões)`);
    if (selectedTags.length > 0) parts.push(`${selectedTags.length} tag(s)`);
    if (selectedKanbanLanes.length > 0) parts.push(`${selectedKanbanLanes.length} kanban`);
    if (selectedStatus.length > 0) parts.push(`status`);
    if (selectedQueueIds.length > 0) parts.push(`${selectedQueueIds.length} fila(s)`);
    if (noTag) parts.push("sem tag");
    if (noKanban) parts.push("sem kanban");
    if (myAttendances) parts.push("meus atendimentos");
    if (unreadFilter) parts.push("não lidas");
    return parts.join(", ");
  };

  const clearAllFilters = () => {
    // FIX URGENTE: so recria os arrays/dispara nova busca se realmente havia algo selecionado -
    // recriar array vazio quando ja estava vazio some com a lista por um instante a toa
    const hadAnything = hasActiveFilter;
    if (searchParam) setSearchParam("");
    if (selectedTags.length > 0) setSelectedTags([]);
    if (selectedKanbanLanes.length > 0) setSelectedKanbanLanes([]);
    if (selectedWhatsapp.length > 0) setSelectedWhatsapp([]);
    if (selectedStatus.length > 0) setSelectedStatus([]);
    if (selectedUsers.length > 0) setSelectedUsers([]);
    if (selectedQueueIds.length > 0) setSelectedQueueIds([]);
    if (noTag) setNoTag(false);
    if (noKanban) setNoKanban(false);
    if (myAttendances) setMyAttendances(false);
    if (unreadFilter) setUnreadFilter(false);
    if (searchInputRef.current) searchInputRef.current.value = "";
    setTab("open");
    if (hadAnything) setForceSearch(prev => !prev);
  };

  const handleFilter = () => {
    // Abrir/fechar o painel nunca apaga os filtros; a limpeza continua explicita.
    setFilter(previous => !previous);
  };

  const handleMyAttendances = () => {
    const next = !myAttendances;
    setMyAttendances(next);
    if (next) {
      setTab("search");
    } else {
      if (selectedTags.length === 0 && selectedKanbanLanes.length === 0 &&
          selectedWhatsapp.length === 0 && selectedStatus.length === 0 &&
          selectedUsers.length === 0 && selectedQueueIds.length === 0 && !searchParam) {
        setTab("open");
      }
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        startWithContactForm={Number.isInteger(Number(user.companyId)) && Number(user.companyId) > 0}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <NewWhatsAppGroupModal
        open={newGroupModalOpen}
        onClose={() => setNewGroupModalOpen(false)}
      />
      <NoReplyFilterModal
        open={noReplyModalOpen}
        initialValue={noReplyPreferences}
        onClose={() => setNoReplyModalOpen(false)}
        onApply={applyNoReply}
        isAdmin={user.profile === "admin"}
      />
      <Dialog open={newItemChoiceOpen} onClose={() => setNewItemChoiceOpen(false)}>
        <DialogTitle>Novo atendimento</DialogTitle>
        <DialogContent>O que voce deseja criar?</DialogContent>
        <DialogActions>
          <Button onClick={() => setNewItemChoiceOpen(false)}>Cancelar</Button>
          <Button color="primary" onClick={() => {
            setNewItemChoiceOpen(false);
            setNewTicketModalOpen(true);
          }}>Criar contato</Button>
          {user.profile === "admin" && user.allowGroup && (
            <Button color="primary" variant="contained" onClick={() => {
              setNewItemChoiceOpen(false);
              setNewGroupModalOpen(true);
            }}>Criar grupo</Button>
          )}
        </DialogActions>
      </Dialog>
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
          onKeyDown={handleSearchKeyDown}
        />
        <Tooltip title="Filtros">
          <IconButton
            size="small"
            aria-label="Abrir filtros"
            onClick={handleFilter}
            className={`${classes.searchFilterButton} ${filter || hasAdvancedFilter ? classes.searchFilterButtonActive : ""}`}
          >
            {filter || hasAdvancedFilter
              ? <FilterAlt style={{ fontSize: 18 }} />
              : <FilterAltOff style={{ fontSize: 18 }} />}
          </IconButton>
        </Tooltip>
      </div>

      {filter === true && (
        <div className={classes.filterPanel}>
          <div className={classes.filterGrid}>
            <div style={{ gridColumn: "1 / -1", minWidth: 0 }}>
              <TicketsQueueSelect
                selectedQueueIds={selectedQueueIds}
                userQueues={user?.queues}
                onChange={(values) => setSelectedQueueIds(values)}
              />
            </div>
            <div style={{ minWidth: 0 }}><TagsFilter onFiltered={handleSelectedTags} /></div>
            <div style={{ minWidth: 0 }}><KanbanLanesFilter onFiltered={handleSelectedKanbanLanes} /></div>
            <div style={{ minWidth: 0 }}><WhatsappsFilter onFiltered={handleSelectedWhatsapps} /></div>
            <div style={{ minWidth: 0 }}><StatusFilter onFiltered={handleSelectedStatus} /></div>
            {profile === "admin" && (
              <div style={{ gridColumn: "1 / -1", minWidth: 0 }}><UsersFilter onFiltered={handleSelectedUsers} /></div>
            )}
          </div>
          <div className={classes.filterQuickOptions}>
            <Chip
              label="Sem tag"
              size="small"
              clickable
              onClick={() => {
                const next = !noTag;
                setNoTag(next);
                if (next) setNoKanban(false);
              }}
              color={noTag ? "primary" : "default"}
              variant={noTag ? "default" : "outlined"}
              className={classes.quickFilterChip}
            />
            <Chip
              label="Sem kanban"
              size="small"
              clickable
              onClick={() => {
                const next = !noKanban;
                setNoKanban(next);
                if (next) setNoTag(false);
              }}
              color={noKanban ? "primary" : "default"}
              variant={noKanban ? "default" : "outlined"}
              className={classes.quickFilterChip}
            />
            {tabOpen === "open" && (
              <Chip
                label="Não lidas"
                size="small"
                clickable
                onClick={() => setUnreadFilter(previous => !previous)}
                color={unreadFilter ? "primary" : "default"}
                variant={unreadFilter ? "default" : "outlined"}
                className={classes.quickFilterChip}
              />
            )}
          </div>
          <div className={classes.filterActions}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                // FIX URGENTE: so dispara nova busca se realmente havia algo selecionado nesses campos
                const hadAnything = selectedTags.length > 0 || selectedKanbanLanes.length > 0 ||
                  selectedWhatsapp.length > 0 || selectedStatus.length > 0 || selectedUsers.length > 0 ||
                  selectedQueueIds.length > 0 || noTag || noKanban || unreadFilter;
                if (selectedTags.length > 0) setSelectedTags([]);
                if (selectedKanbanLanes.length > 0) setSelectedKanbanLanes([]);
                if (selectedWhatsapp.length > 0) setSelectedWhatsapp([]);
                if (selectedStatus.length > 0) setSelectedStatus([]);
                if (selectedUsers.length > 0) setSelectedUsers([]);
                if (selectedQueueIds.length > 0) setSelectedQueueIds([]);
                if (noTag) setNoTag(false);
                if (noKanban) setNoKanban(false);
                if (unreadFilter) setUnreadFilter(false);
                if (hadAnything) setForceSearch(prev => !prev);
              }}
            >
              Limpar
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={applyFilters}
            >
              OK — Aplicar
            </Button>
          </div>
        </div>
      )}

      {/* FIX AVISO-FILTRO: faixa visivel avisando que ha filtro ativo, mesmo com o painel fechado */}
      {hasActiveFilter && (
        <div className={classes.activeFilterBanner}>
          <FilterAlt style={{ color: "#d78317", fontSize: 18 }} />
          <span className={classes.activeFilterText}>
            Filtro ativo{buildActiveFilterDescription() ? `: ${buildActiveFilterDescription()}` : ""} — nem todas as conversas estão sendo exibidas
          </span>
          <Button
            size="small"
            onClick={clearAllFilters}
            className={classes.clearFilterButton}
          >
            Limpar filtro
          </Button>
        </div>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center">
          <Grid item className={classes.toolbarActions}>
            <Can
              role={user.profile}
              perform="tickets-manager:showall"
              yes={() => (
                <Tooltip
                  title={showAllTickets ? "Exibindo todos os atendimentos" : "Exibir todos os atendimentos"}
                  placement="top"
                >
                  <ToggleButton
                    aria-label="Alternar visualização de todos os atendimentos"
                    className={`${classes.standardButton} ${showAllTickets ? classes.activeButton : ''}`}
                    value="uncheck"
                    selected={showAllTickets}
                    onChange={handleToggleShowAllTickets}
                  >
                    {showAllTickets ? (
                      <VisibilityIcon className={`${classes.standardIcon} ${classes.activeIcon}`} />
                    ) : (
                      <VisibilityOffIcon className={classes.standardIcon} />
                    )}
                  </ToggleButton>
                </Tooltip>
              )}
            />
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button
                    className={classes.yesButton}
                    size="small"
                    onClick={CloseAllTicket}
                  >
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button
                    className={classes.noButton}
                    size="small"
                    onClick={handleSnackbarClose}
                  >
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />
            <Tooltip title={i18n.t("tickets.inbox.newTicket")} placement="top">
              <IconButton
                aria-label={i18n.t("tickets.inbox.newTicket")}
                className={classes.standardButton}
                onClick={() => setNewItemChoiceOpen(true)}
              >
                <PersonAddAlt1Outlined className={classes.standardIcon} />
              </IconButton>
            </Tooltip>
            {user.profile === "admin" && (
              <Tooltip title={i18n.t("tickets.inbox.closedAll")} placement="top">
                <IconButton
                  aria-label={i18n.t("tickets.inbox.closedAll")}
                  className={classes.standardButton}
                  onClick={handleSnackbarOpen}
                >
                  <PlaylistAddCheckOutlined className={classes.standardIcon} />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={i18n.t("tickets.inbox.open")} placement="top">
              <IconButton
                aria-label={i18n.t("tickets.inbox.open")}
                className={`${classes.standardButton} ${tab === "open" ? classes.activeButton : ''}`}
                onClick={() => handleChangeTab(null, "open")}
              >
                <ForumOutlined
                  className={`${classes.standardIcon} ${tab === "open" ? classes.activeIcon : ''}`}
                />
              </IconButton>
            </Tooltip>

            <span className={classes.toolbarSpacer} />

{noReplyEnabled && (
  <Badge
    badgeContent={noReplyActive ? noReplyCount : 0}
    max={999}
    showZero
    invisible={!noReplyActive}
    classes={{ badge: classes.noReplyBadge }}
  >
    <Chip
      icon={<NotificationsActiveOutlined style={{ fontSize: 15 }} />}
      label="Sem retorno"
      size="small"
      clickable
      onClick={noReplyActive ? deactivateNoReply : openNoReplyDefault}
      color={noReplyActive ? "primary" : "default"}
      variant={noReplyActive ? "default" : "outlined"}
      className={`${classes.noReplyChip} ${classes.toolbarHighlightChip}`}
    />
  </Badge>
)}
<Chip
  icon={<WalletIcon style={{ fontSize: 14 }} />}
  label={(
    <span className={classes.myAttendancesLabel}>
      <span>Meus</span>
      <span>Atendimentos</span>
    </span>
  )}
  size="small"
  clickable
  onClick={handleMyAttendances}
  color={myAttendances ? "primary" : "default"}
  variant={myAttendances ? "default" : "outlined"}
  className={`${classes.quickFilterChip} ${classes.toolbarHighlightChip} ${classes.myAttendancesChip}`}
/>
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        {!noReplyActive && <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* AUTOMAÇÕES - apenas para usuarios com showFlow habilitado */}
          {(user.profile === "admin" || user.showFlow === "enabled") && <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" className={classes.compactTabLabel}>
                {chatbotCount > 0 && <span className={classes.compactTabCount}>{chatbotCount > 999 ? "999+" : chatbotCount}</span>}
                <Grid item>
                    <AndroidIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "chatbot" ? estratizaGold : "inherit",
                      }}
                    />
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "chatbot" ? 700 : 500,
                      color: tabOpen === "chatbot" ? estratizaGold : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    Automações
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"chatbot"}
            name="chatbot"
            classes={{ root: classes.tabPanelItem }}
          />}

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" className={classes.compactTabLabel}>
                {pendingCount > 0 && <span className={classes.compactTabCount}>{pendingCount > 999 ? "999+" : pendingCount}</span>}
                <Grid item>
                    <ClockIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "pending" ? estratizaGold : "inherit",
                      }}
                    />
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "pending" ? 700 : 500,
                      color: tabOpen === "pending" ? estratizaGold : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />


          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" className={classes.compactTabLabel}>
                {openCount > 0 && <span className={classes.compactTabCount}>{openCount > 999 ? "999+" : openCount}</span>}
                <Grid item>
                    <MessageSharpIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "open" ? estratizaGold : "inherit",
                      }}
                    />
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "open" ? 700 : 500,
                      color: tabOpen === "open" ? estratizaGold : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />


          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" className={classes.compactTabLabel}>
                  {groupingCount > 0 && <span className={classes.compactTabCount}>{groupingCount > 999 ? "999+" : groupingCount}</span>}
                  <Grid item>
                      <Group
                        style={{
                          fontSize: 20,
                          color: tabOpen === "group" ? estratizaGold : "inherit",
                        }}
                      />
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 11,
                        lineHeight: "14px",
                        fontWeight: tabOpen === "group" ? 700 : 500,
                        color: tabOpen === "group" ? estratizaGold : "inherit",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}

        </Tabs>}

        <Paper className={classes.ticketsWrapper}>
          {noReplyActive ? (
            <>
              <div style={{ padding: "2px 6px", minHeight: 30, background: "#e3f2fd", color: "#0d47a1", fontSize: 12, fontWeight: 600, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 4, flexShrink: 0 }}>
                <Button size="small" disabled={noReplySortSaving} onClick={toggleNoReplySort} style={{ textTransform: "none", minWidth: 0, whiteSpace: "nowrap" }}>
                  {noReplyPreferences.sortOrder === "DESC" ? "Menor tempo primeiro" : "Maior tempo primeiro"} ↕
                </Button>
                <Button size="small" onClick={() => setNoReplyModalOpen(true)} style={{ textTransform: "none", minWidth: 0 }}>
                  Filtrar
                </Button>
                <Button size="small" onClick={deactivateNoReply} style={{ textTransform: "none", minWidth: 0 }}>
                  Sair
                </Button>
              </div>
              <NoReplyTicketsList
                preferences={noReplyPreferences}
                setTabOpen={setTabOpen}
                onCount={setNoReplyCount}
              />
            </>
          ) : <>
          <TicketsList
            status="open"
            showAll={canShowAllTickets && showAllTickets}
            sortTickets="DESC"
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            countWithUnreadOnly={true}
            unreadFilter={unreadFilter}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            myAttendances={myAttendances}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets="DESC"
            showAll={canShowAllTickets && showAllTickets}
            updateCount={(val) => setPendingCount(val)}
            countByTickets={true}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={canShowAllTickets && showAllTickets}
              sortTickets="DESC"
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              countWithUnreadOnly={true}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              searchParam={searchParam}
              searchOnMessages={searchOnMessages}
              users={selectedUsers}
              whatsappIds={selectedWhatsapp}
              tags={selectedTags}
              kanbanTags={selectedKanbanLanes}
              noTag={noTag ? "true" : ""}
              noKanban={noKanban ? "true" : ""}
            />
          )}
          {(user.profile === "admin" || user.showFlow === "enabled") && <TicketsList
            status="chatbot"
            showAll={canShowAllTickets && showAllTickets}
            sortTickets="DESC"
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setChatbotCount(val)}
            countByTickets={true}
            style={applyPanelStyle("chatbot")}
            setTabOpen={setTabOpen}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />}
          </>}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={canShowAllTickets && showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
		  searchParam={searchParam}
		  searchOnMessages={searchOnMessages}
		  users={selectedUsers}
		  whatsappIds={selectedWhatsapp}
		  tags={selectedTags}
		  kanbanTags={selectedKanbanLanes}
		  noTag={noTag ? "true" : ""}
		  noKanban={noKanban ? "true" : ""}
		  forceSearch={forceSearch}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={searchStatusFilter}
              searchParam={searchParam}
              showAll={!myAttendances}
              tags={selectedTags}
              kanbanTags={selectedKanbanLanes}
              noKanban={noKanban}
              noTag={noTag}
              users={searchUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
              sortTickets="DESC"
              filterAcrossStatuses={hasAdvancedFilter}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={searchStatusFilter}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noKanban={noKanban}
            noTag={noTag}
            users={searchUsers}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
            sortTickets="DESC"
            filterAcrossStatuses={hasAdvancedFilter}
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
